import { AT_BOARD_ACTION_DELETE, IBoardActionDeleteAction } from './types';

export const boardActionDelete = (
    boardId: number
): IBoardActionDeleteAction => ({
    type: AT_BOARD_ACTION_DELETE,
    boardId
});
